<pl-carousel *ngIf="block" [slidesContent]="block.data.items" [showDots]="!!block.data.config.showDots" />
